import React, { useCallback, useState } from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'
import Stack from '@mui/material/Stack'
import Toolbar from '@mui/material/Toolbar'

import Topbar from './Topbar'

type ContextType = {
  topbarContentContainer: HTMLDivElement | null
}

export type DiagnosticLayoutProps = {}

export default function DiagnosticLayout(props: DiagnosticLayoutProps) {
  const [topbarContentContainer, setTopbarContentContainer] = useState<HTMLDivElement | null>(null)

  const handleSetTopbarContentContainerRef = useCallback((el: HTMLDivElement | null) => {
    setTopbarContentContainer(el)
  }, [])

  return (
    <Stack
      sx={{
        height: '100vh',
        backgroundColor: (theme) => theme.palette.background.default,
      }}
    >
      <Topbar setContentContainerRef={handleSetTopbarContentContainerRef} />
      <Toolbar />
      <Outlet context={{ topbarContentContainer }} />
    </Stack>
  )
}

export function useDiagnosticLayout() {
  return useOutletContext<ContextType>()
}
